export default "__VITE_ASSET__DlSsOcRZ__"